function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var QuestionMark = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs(SvgIcon, _extends({
    "data-testid": "QuestionMarkIcon"
  }, props, {
    ref: ref,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3 6a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2H7a4 4 0 0 1-4-4V6z",
      opacity: ".6"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M7 2a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H7zm5.611 11.347-.005-.162a16.961 16.961 0 0 1-.008-.435c0-.583.084-1.09.254-1.519a3.48 3.48 0 0 1 .602-.98c.2-.237.554-.576 1.064-1.02.49-.427.808-.766.947-1.007a1.51 1.51 0 0 0 .204-.771c0-.513-.201-.961-.611-1.353-.41-.393-.91-.588-1.508-.588-.578 0-1.054.176-1.437.53-.384.354-.641.92-.765 1.7l-.025.157L9.5 7.685l.02-.165c.14-1.128.558-2 1.256-2.609.698-.608 1.617-.911 2.75-.911 1.198 0 2.162.325 2.885.977.724.653 1.089 1.45 1.089 2.38 0 .538-.128 1.037-.385 1.492-.253.45-.739.987-1.458 1.616-.465.407-.768.706-.905.89a1.87 1.87 0 0 0-.297.625c-.065.239-.104.642-.115 1.204l-.003.163H12.61zM12.501 17v-1.803H14.4V17h-1.897z",
      clipRule: "evenodd"
    })]
  }));
});
QuestionMark.displayName = 'QuestionMarkIcon';
export default QuestionMark;